export default class BuyOnline {
  constructor() {
    this.init();
  }

  init() {
    this.scrolltoreview();
    $('body').on('click', '.buy-online .btn', (event) => {
      event.preventDefault();
      $('.shops-dropdown').toggle();
    });
    $('body').on('click', '.store-item a', (event) => {
      var productId = this.getProductId('productId', dataLayer) ? this.getProductId('productId', dataLayer) : '';
      var retailerName = $(event.currentTarget.parentElement).find('a:not(.store-image)').text();
      var retailerLink = $(event.currentTarget.parentElement).find('a:not(.store-image)').attr('href');
      var retailerImageAltText = $(event.currentTarget.parentElement).find('img').attr('alt');
      var countryCode = $('html').attr('lang');
      var isEcommerceDataLayerEventRequired = ['de','en'];
      window.eventBus.$emit('store-item-datalayer', retailerImageAltText);
      if (retailerLink && isEcommerceDataLayerEventRequired.includes(countryCode)) {
        dataLayer.push({
          'event': 'uaevent',
          'eventCategory': 'Ecommerce',
          'eventAction': 'redirection::' + retailerImageAltText,
          'eventLabel': retailerLink,
          'ecommerce': 'undefined'
        });
      }
    });
  }
  getProductId(productId, dataLayer) {
    for (var i = 0; i < dataLayer.length; i++) {
      if (dataLayer[i].productId)
        return dataLayer[i].productId;
    }
  }
  scrolltoreview() {
    var getlanguage = document.documentElement.lang;
    var language = "de" && "en";
    if (getlanguage == language) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        var keystring = pair[0];
        var givenstring1 = "gclid";
        var givenstring2 = "UTM_source";
        if (keystring.toUpperCase() === givenstring1.toUpperCase()) {
          window.location.hash = '#reviews';
        }
        if (keystring.toUpperCase() === givenstring2.toUpperCase()) {
          window.location.hash = '#reviews';
        }

      }
    }

    /*data privacy anchor*/
    if (window.location.href.indexOf('#info') > -1) {
      if (($(window).width() <= 375) && ($(window).width() > 340)) {
        $('html,body').animate({ scrollTop: 2280 }, 'slow');
      }
      if ($(window).width() <= 340) {
        $('html,body').animate({ scrollTop: 2690 }, 'slow');
      }
      if (($(window).width() < 768) && ($(window).width() > 375)) {
        $('html,body').animate({ scrollTop: 2085 }, 'slow');
      }
      if (($(window).width() <= 1024) && ($(window).width() >= 768)) {
        $('html,body').animate({ scrollTop: 1140 }, 'slow');
      }
      if ($(window).width() > 1024) {
        $('html,body').animate({ scrollTop: 900 }, 'slow');
      }
    }
  }

}